import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { REACT_APP_API_URL } from "../../../../../env";
import "bootstrap/dist/css/bootstrap.min.css";

const AdvanceBookingsList = () => {
  const [bookings, setBookings] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchHotel, setSearchHotel] = useState("");
  const [searchGuest, setSearchGuest] = useState("");
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalText, setModalText] = useState("");

  useEffect(() => {
    fetch(`${REACT_APP_API_URL}api/dashboard/admin/advance-bookings`)
      .then((res) => res.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setBookings(data.data);
          setFiltered(data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching bookings:", err);
        setLoading(false);
      });
  }, []);

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        position: "sticky",
        top: 0,
        zIndex: 1,
        whiteSpace: "nowrap",
        overflow: "visible",
        textOverflow: "clip",
      },
    },
    headRow: {
      style: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        border: "1px solid #dee2e6",
      },
    },
  };

  useEffect(() => {
    const lowerHotel = searchHotel.toLowerCase();
    const lowerGuest = searchGuest.toLowerCase();

    const filteredData = bookings.filter(
      (item) =>
        item.HotelName.toLowerCase().includes(lowerHotel) &&
        item.GuestName.toLowerCase().includes(lowerGuest)
    );

    setFiltered(filteredData);
  }, [searchHotel, searchGuest, bookings]);

  const openModal = (text) => {
    setModalText(text);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalText("");
    setModalOpen(false);
  };

  const columns = [
    {
      name: "Ref",
      selector: (row) => row.Ref || "",
    },
    {
      name: "Guest Name",
      selector: (row) => row.GuestName || "",
      sortable: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.Mobile || "",
    },
    {
      name: "Email",
      selector: (row) => row.Email || "",
    },
    {
      name: "Hotel Name",
      selector: (row) => row.HotelName || "",
      sortable: true,
    },
    {
      name: "From Date",
      selector: (row) => {
        if (!row.FromDate) return "";
        const [year, month, day] = row.FromDate.split("T")[0].split("-");
        return `${day}-${month}-${year}`;
      },
    },
    {
      name: "To Date",
      selector: (row) => {
        if (!row.ToDate) return "";
        const [year, month, day] = row.ToDate.split("T")[0].split("-");
        return `${day}-${month}-${year}`;
      },
    },

    {
      name: "Purpose",
      selector: (row) => row.Purpose || "",
    },
    {
      name: "Remarks",
      cell: (row) => {
        const fullText = row.Remarks || "";
        const shortText =
          fullText.length > 9 ? fullText.slice(0, 9) + "..." : fullText;
        return (
          <span
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => openModal(fullText)}
            title="Click to view full remarks"
          >
            {shortText}
          </span>
        );
      },
    },
  ];

  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header mb-4">
        <span className="admin-page-kicker">Hotel Reservations</span>
        <h2 className="admin-page-title fw-bold mb-1">Advance Booking Table</h2>
        <p className="admin-page-description mb-0">Search upcoming hotel bookings by property or guest name.</p>
      </div>
      <div className="card admin-surface-card">
        <div className="admin-surface-header">
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Hotel Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Hotel Name"
                value={searchHotel}
                onChange={(e) => setSearchHotel(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Guest Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Guest Name"
                value={searchGuest}
                onChange={(e) => setSearchGuest(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="admin-surface-body">
          <div className="admin-table-shell">
            <DataTable
              columns={columns}
              data={filtered}
              progressPending={loading}
              pagination
              paginationPerPage={100}
              paginationRowsPerPageOptions={[50, 100, 500]}
              highlightOnHover
              customStyles={customStyles}
              responsive
              striped
              noDataComponent={
                <div className="admin-empty-state my-3">
                  No matching bookings found.
                </div>
              }
              fixedHeader
              fixedHeaderScrollHeight="500px"
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div
          className="modal fade show d-block admin-modal"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Full Remarks</h5>
              </div>
              <div className="modal-body">
                <p className="mb-0">{modalText}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvanceBookingsList;
